/**
 * Hace arrastrable un elemento flotante sobre el mapa.
 *
 * Mientras se arrastra hay que desactivar el pan de Leaflet: si no, mover el
 * rótulo mueve también el mapa debajo y el operador pierde el encuadre.
 */

export function makeDraggable(element, map) {
  element.style.cursor = 'grab';

  let startX = 0;
  let startY = 0;
  let originX = 0;
  let originY = 0;
  let dragging = false;

  const onPointerDown = (event) => {
    const wrap = element.parentElement.getBoundingClientRect();
    const rect = element.getBoundingClientRect();
    originX = rect.left - wrap.left;
    originY = rect.top - wrap.top;
    element.style.left = `${originX}px`;
    element.style.top = `${originY}px`;
    element.style.bottom = 'auto';
    element.style.transform = 'none';
    startX = event.clientX;
    startY = event.clientY;
    dragging = true;
    event.preventDefault();
    event.stopPropagation();
    map?.dragging?.disable();
  };

  const onPointerMove = (event) => {
    if (!dragging) return;
    element.style.left = `${originX + event.clientX - startX}px`;
    element.style.top = `${originY + event.clientY - startY}px`;
  };

  const onPointerUp = () => {
    if (!dragging) return;
    dragging = false;
    map?.dragging?.enable();
  };

  element.addEventListener('pointerdown', onPointerDown);
  window.addEventListener('pointermove', onPointerMove);
  window.addEventListener('pointerup', onPointerUp);

  return () => {
    element.removeEventListener('pointerdown', onPointerDown);
    window.removeEventListener('pointermove', onPointerMove);
    window.removeEventListener('pointerup', onPointerUp);
  };
}
